export default __webpack_public_path__ + "static/media/3_guest_group.bd23934d.svg";